export const lists = {
  // Lists Page
  listsPageTitle: 'Listas',
  lists: 'Mis Listas',
  noLists: 'No se encontraron listas',
  addList: 'Agregar Lista',
  editList: 'Editar Lista',
  deleteList: 'Eliminar Lista',
  searchLists: 'Buscar listas...',
  filterLists: 'Filtrar Listas',
  clearFilters: 'Limpiar Filtros',
  loading: 'Cargando...',
  
  // List Details
  listDetails: 'Detalles de la Lista',
  viewDetails: 'Ver Detalles',
  duplicate: 'Duplicar Lista',
  close: 'Cerrar',
  
  // Categories
  categories: 'Categorías',
  category: 'Categoría',
  general: 'General',
  shopping: 'Compras',
  travel: 'Viajes',
  work: 'Trabajo',
  personal: 'Personal',
  other: 'Otro',
  allCategories: 'Todas las Categorías',
  selectCategory: 'Seleccionar una categoría',
  
  // List Form
  listTitle: 'Título',
  description: 'Descripción',
  color: 'Color',
  cancel: 'Cancelar',
  save: 'Guardar',
  
  // List Items
  addItem: 'Agregar Elemento',
  editItem: 'Editar Elemento',
  deleteItem: 'Eliminar Elemento',
  itemTitle: 'Título del Elemento',
  itemDescription: 'Descripción (opcional)',
  markCompleted: 'Marcar como completado',
  markPending: 'Marcar como pendiente',
  noItems: 'Aún no hay elementos en esta lista',
  
  // Templates
  useAsTemplate: 'Usar como Plantilla',
  saveAsTemplate: 'Guardar como Plantilla',
  templates: 'Plantillas',
  createFromTemplate: 'Crear desde Plantilla',
  
  // Priorities
  priority: 'Prioridad',
  lowPriority: 'Baja',
  mediumPriority: 'Media',
  highPriority: 'Alta',
  
  // Tags
  tags: 'Etiquetas',
  addTag: 'Agregar etiqueta',
  removeTag: 'Eliminar etiqueta',
  
  // Sub-tasks
  addSubtask: 'Agregar Subtarea',
  subtasks: 'Subtareas',
  parentTask: 'Tarea Principal',
  
  // Template Categories
  household: 'Hogar',
  wellness: 'Bienestar',
  
  // Progress
  progress: 'Progreso',
  completed: 'Completado',
  pending: 'Pendiente',
  totalItems: 'Total de Elementos',
  
  // Export & Print
  export: 'Exportar',
  exportAsPDF: 'Exportar como PDF',
  exportAsText: 'Exportar como Texto',
  printList: 'Imprimir Lista',
  
  // Notifications
  listCreated: 'Lista creada exitosamente',
  listUpdated: 'Lista actualizada exitosamente',
  listDeleted: 'Lista eliminada exitosamente',
  itemAdded: 'Elemento agregado exitosamente',
  itemUpdated: 'Elemento actualizado exitosamente',
  itemDeleted: 'Elemento eliminado exitosamente',
  
  // Confirmations
  confirmDeleteList: '¿Estás seguro de que quieres eliminar esta lista?',
  confirmDeleteItem: '¿Estás seguro de que quieres eliminar este elemento?',
  
  // Validation
  titleRequired: 'El título es requerido',
  itemTitleRequired: 'El título del elemento es requerido',
  
  // Authentication
  authRequired: 'Autenticación Requerida',
  pleaseLoginToViewLists: 'Por favor inicia sesión para ver y gestionar tus listas',
};